import React, { useEffect, useRef, useState } from 'react'
import Card from '@auteco/components/sharedComponents/Card/Card'
import {
  getGDCClusters,
  getGDCMatriz,
  getGDCRoadMap,
  postProccessOk,
  putGDCRoadMap
} from '@auteco/services/gdcServices'
import CardBody from '@auteco/components/sharedComponents/Card/CardBody'
import {
  Chart as ChartJS,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
  Chart,

} from 'chart.js'
import { Paper, Button as MaterialUIButton, Typography } from '@material-ui/core'
import { clustersNames } from '@auteco/constants'
import StopIcon from '@material-ui/icons/Stop'
import { getPermissions } from '@auteco/utils/Common'
import CardTitle from '@auteco/components/sharedComponents/CardTitle'
import Button from '../../sharedComponents/CustomButtons/Button'
import { RoadMapCard, RoadMapCardButton } from './components'
import { useStyles } from './styles'
import { DialogMessage } from './components/DialogMessage'
import { Alert } from '../Alert'

ChartJS.register(LinearScale, PointElement, Tooltip, Legend)

const quadrantsColors = {
  shortTerm: 'green',
  longTerm: 'blue',
  basic: 'orange',
  avoid: 'red'
}

const quadrants = {
  id: 'quadrants',
  beforeDraw(chart) {
    const { ctx, chartArea: { left, top }, scales: { x, y } } = chart;
    ctx.save()
    const quadrant = (xleft, ytop, xright, ybottom, color) => {
      ctx.lineWidth = '6px';
      ctx.strokeStyle = color
      ctx.strokeRect(x.getPixelForValue(xleft), y.getPixelForValue(ytop), x.getPixelForValue(xright) - left, y.getPixelForValue(ybottom) - top)
      ctx.restore()
    }
    // quadrant(0, 4.5, 2.25, 2.25, quadrantsColors.shortTerm)
    // quadrant(2.25, 4.5, 2.25, 2.25, quadrantsColors.longTerm)
    // quadrant(0, 2.25, 2.25, 2.25, quadrantsColors.basic)
    // quadrant(2.25, 2.25, 2.25, 2.25, quadrantsColors.avoid)
    quadrant(0, 4, 2, 2, quadrantsColors.shortTerm)
    quadrant(2, 4, 2, 2, quadrantsColors.longTerm)
    quadrant(0, 2, 2, 2, quadrantsColors.basic)
    quadrant(2, 2, 2, 2, quadrantsColors.avoid)
  }
};

export const options = {
  scales: {
    x: {
      grid: {
        display: false,
      },
      title: {
        display: true,
        text: 'Complejidad',
      },
      min: 0,
      max: 4,
      ticks: {
        display: false,
      }
    },
    y: {
      grid: {
        display: false,
      },
      title: {
        display: true,
        text: 'Impacto',
      },
      min: 0,
      max: 4,
      ticks: {
        display: false,
      }
    },
  },
  options: {
    interaction: {
      intersect: false,
      mode: 'index',
    },
    scales: {
      y: {
        beginAtZero: true
      }
    }
  },
}

export const data = {
  datasets: [],
}

const Roadmap = ({ onCloseOption, selectOption }) => {
  const onSelect = () => { }
  const [clusterlist, setClusterList] = useState([])
  const [matriz, setMatriz] = useState({
    datasets: [],
  })
  const [roadMap, setRoadMap] = useState([])
  const [dialogInfo, setDialogInfo] = useState({ open: false, id: 0 })
  const [alertInfo, setAlertInfo] = useState({ open: false, onClose: () => { }, title: '', content: '', onlyButton: false, btn1Txt: '', btn2Txt: '', btn1Func: () => { }, btn2Func: () => { } })
  const classes = useStyles()
  const bubbleRef = useRef(null)

  const permissions = getPermissions()

  const createChartDataset = (matriz_impacto) => {
    const impacto = matriz_impacto.reduce((acumulador, objeto) => {
      const { cluster_id } = objeto;
      const index = acumulador.findIndex((grupo) => grupo[0]?.cluster_id === cluster_id);
      if (index !== -1) {
        acumulador[index].push(objeto);
      } else {
        acumulador.push([objeto]);
      }
      return acumulador;
    }, [])
    const datasets = []
    for (let i = 0; i < impacto.length; i++) {
      const info = impacto[i].map(item => ({
        x: item.x,
        y: item.y,
        r: 10,
        label: '',
        name: item.punto,
        id: item.punto_guia_id
      }))
      datasets.push({
        label: clustersNames.filter(cluster => cluster.id === impacto[i][0].cluster_id)[0].name,
        data: info,
        backgroundColor: impacto[i][0].color,
      })
    }
    const dataset = {
      // labels,
      datasets
    }
    return dataset
  }

  const reloadGDCClusters = () =>
    getGDCClusters({ partner: selectOption.solicitante }).then(
      ({ cluster }) => {
        if (cluster.length > 0) {
          const sortedClusters = cluster.sort((a, b) => Number(a.id_cluster) - Number(b.id_cluster))
          setClusterList(sortedClusters)
        }
      },
    )

  const reloadGDCSRoadMap = () =>
    getGDCRoadMap({ partner: selectOption.solicitante }).then(
      ({ hoja_ruta }) => {
        const sortedRoadMap = hoja_ruta.sort((a, b) => Number(a.prioridad) - Number(b.prioridad))
        setRoadMap(sortedRoadMap)
      },
    )

  const reloadGDCMatriz = () =>
    getGDCMatriz({ partner: selectOption.solicitante }).then(
      ({ matriz_impacto }) => {
        if (matriz_impacto.length > 0) {
          // const dataset = createChartDataset(matriz_impacto)
          setMatriz(matriz_impacto)
        }
      },
    )

  const handleBubbleClick = (event) => {
    const activeElements = event?.chart?.getElementsAtEventForMode(event, 'nearest', { intersect: true }, false);
    if (activeElements && activeElements.length > 0) {
      const { datasetIndex, index } = activeElements[0]
      const clickedData = createChartDataset(matriz).datasets[datasetIndex].data[index];
      setDialogInfo({ open: true, id: clickedData.id })
    }
  }

  const handleCloseDialog = () => {
    setDialogInfo({ open: false, id: 0 })
  }

  const compareCards = (arr1, arr2) => {
    const differentObjects = arr1.filter((item1, index) => {
      const item2 = arr2[index]
      const keys1 = Object.keys(item1);

      let differentValues = false;

      keys1?.forEach(key => {
        if (item1[key] !== item2[key]) {
          differentValues = true;
        }
      });
      return differentValues;
    });
    return differentObjects
  };

  const updatePriority = (info) => info.map((item, i) => ({ ...item, prioridad: i + 1 }))

  const updateItems = async ({ items }) => {
    const updatePromises = items.map(async (item) => {
      const body = {
        punto_guia_id: item.punto_id,
        titulo: item.titulo,
        texto: item.texto,
        valorar: item.valoracion,
        costo: item.costo,
        finalizacion: item.finalizacion,
        solicitante: item.socio_id,
        hoja_ruta_id: item.id,
        prioridad: item.prioridad,
        cluster_id: item.cluster_id,
        punto: item.punto
      };
      await putGDCRoadMap({ params: body });
    });

    await Promise.all(updatePromises);
  }

  const handleDragStart = (event, item, index) => {
    if (selectOption?.isEnabled && roadMap.length > 1) {
      event.dataTransfer.setData('text/plain', JSON.stringify({ item, sourceList: 'roadMapList', index }));
    }
  }

  const handleDragOver = (event) => {
    if (selectOption?.isEnabled && roadMap.length > 1) {
      event.preventDefault();
    }
  };

  const handleReorder = (list, sourceIndex, targetIndex, item) => {
    const updatedList = [...list];
    updatedList.splice(sourceIndex, 1);
    updatedList.splice(targetIndex, 0, item);
    return updatedList;
  }

  const handleDrop = async (event, targetIndex) => {
    event.preventDefault();
    const info = JSON.parse(event.dataTransfer.getData('text/plain'))
    const { item: { titulo, texto, valoracion, prioridad, id, costo, finalizacion, punto_id, socio_id, estado, cluster_id, punto } } = info
    const sourceIndex = info.index
    const prevList = [...roadMap]
    const orderedList = handleReorder(prevList, sourceIndex, targetIndex, { titulo, texto, valoracion, prioridad, id, punto_id, costo, finalizacion, socio_id, estado, cluster_id, punto })
    const updatedList = updatePriority(orderedList)
    const differentCards = compareCards(updatedList, orderedList)
    updateItems({ items: differentCards })
    setRoadMap(updatedList)
  }

  const onEditCard = async ({ item, index }) => {
    const prevList = [...roadMap]
    const orderedList = handleReorder(prevList, index, item.prioridad - 1, item)
    const updatedList = updatePriority(orderedList)
    const differentCards = compareCards(updatedList, prevList)
    updateItems({ items: differentCards })
    setRoadMap(updatedList)
  }
  const sendRoadmap = async () => {
    const body = {
      paso: 2,
      solicitante: selectOption.solicitante
    }
    const response = await postProccessOk({ params: body })
    if (response.success === 1) {
      onCloseOption()
      setAlertInfo({ ...alertInfo, open: false })
    }
  }
  const finishRoadmap = async () => {
    setAlertInfo(
      {
        open: true,
        onClose: () => setAlertInfo({ ...alertInfo, open: false }),
        title: '!Espera!',
        content: '¿Estás seguro de que deseas terminar este proceso?',
        onlyButton: false,
        btn1Txt: 'Aceptar',
        btn2Txt: 'Cancelar',
        btn1Func: () => sendRoadmap(),
        btn2Func: () => setAlertInfo({ ...alertInfo, open: false })
      }
    )
  }

  useEffect(() => {
    Promise.all([
      reloadGDCClusters(),
      reloadGDCSRoadMap(),
      reloadGDCMatriz(),
    ]).catch(() => { })
  }, [])

  const chartRef = useRef(null);
  useEffect(() => {
    if (bubbleRef.current && matriz.length > 0) {
      // Si hay una instancia anterior del gráfico, destruirla primero
      if (chartRef.current) {
        chartRef.current.destroy();
      }

      const ctx = bubbleRef.current.getContext('2d');
      const chart = new Chart(ctx, {
        type: 'bubble',
        data: createChartDataset(matriz),
        options: {
          ...options,
          plugins: {
            tooltip: {
              callbacks: {
                label: (context) => {
                  const label = context.dataset.label || '';
                  const quest = context.element.$context.raw.name
                  if (label) {
                    return `${label}: ${quest}`;
                  }
                  return '';
                },
              },
            },
          },
          onClick: selectOption.isEnabled && handleBubbleClick
        },
        plugins: [quadrants]
      });
      chartRef.current = chart;
    }
  }, [matriz, options]);

  return (
    <>
      <Alert info={alertInfo} />
      <DialogMessage
        open={dialogInfo.open}
        onClose={handleCloseDialog}
        id={dialogInfo.id}
        partner={selectOption.solicitante}
        priority={roadMap.length + 1}
        reload={reloadGDCSRoadMap}
      />
      <Button onClick={onCloseOption}>Volver</Button>
      <Card>
        <CardBody>
          <CardTitle
            title="Hoja de ruta"
            subTitle={`${selectOption.razon_social} - ${selectOption.solicitante}`}
          />
        </CardBody>
        <div className={classes.gridContainer}>
          <div className={classes.gridItem}>
            <div className={classes.itemDetail}>
              {clusterlist.length > 0 &&
                clusterlist.map((item) => {
                  const isSelected = true
                  return (
                    <RoadMapCardButton
                      item={item}
                      key={item.id}
                      onSelect={onSelect}
                      isSelected={isSelected}
                    />
                  )
                })}
            </div>
            <Card className={classes.cardBodyContainer}>
              <Card className={classes.chartInfoContainer}>
                <Typography className={classes.chartInfoTitle}>
                  Corto plazo
                  <StopIcon style={{ color: quadrantsColors.shortTerm }} />
                </Typography>
                <Typography className={classes.chartInfoTitle}>
                  Largo plazo
                  <StopIcon style={{ color: quadrantsColors.longTerm }} />
                </Typography>
                <Typography className={classes.chartInfoTitle}>
                  Básico
                  <StopIcon style={{ color: quadrantsColors.basic }} />
                </Typography>
                <Typography className={classes.chartInfoTitle}>
                  Evitar
                  <StopIcon style={{ color: quadrantsColors.avoid }} />
                </Typography>
              </Card>
              <CardBody className={classes.cardBody}>
                <canvas ref={bubbleRef} />
              </CardBody>
            </Card>
          </div>
          <div className={`${classes.gridItem} ${classes.gridItemFirst}`}>
            <Paper
              id="element-1"
              draggable="true"
              className={classes.title}
              onDragStart={(event) => handleDragStart(event, 'Hoja de ruta', 'roadMapList', 0)}
            >
              Hoja de ruta
            </Paper>
            <div className={classes.cardsContainer}>
              {roadMap.length > 0 &&
                roadMap.map((item, i) =>
                  <RoadMapCard
                    index={i}
                    item={item}
                    isEnabled={selectOption.isEnabled}
                    onDragStart={handleDragStart}
                    onDragOver={handleDragOver}
                    onDrop={handleDrop}
                    reloadGDCSRoadMap={reloadGDCSRoadMap}
                    onEditCard={onEditCard}
                  />)}
              <Paper
                draggable="true"
                onDragStart={(event) => handleDragStart(event, 'Hoja de ruta', 'roadMapList', -1)}
                onDragOver={handleDragOver}
                onDrop={(event) => handleDrop(event, 'roadMapList', -1)}
              />
            </div>
          </div>
        </div>
        {permissions[58] === 5 &&
          <MaterialUIButton
            variant='contained'
            color='primary'
            className={classes.finishBtn}
            disabled={!selectOption?.isEnabled}
            onClick={finishRoadmap}
          >
            Finalizado
          </MaterialUIButton>
        }
      </Card >
    </>
  )
}

export { Roadmap }
